module.exports = __webpack_public_path__ + "static/accessibility-59b87ec5a24fc46c7c870adeb184bcde.png";